'use client';

import { twMerge } from 'tailwind-merge';
import { Container } from '../../../../../components/Container/Container';

import { TypeBlogPostSkeleton } from '@generated/contentful';
import { Entry } from 'contentful';
import { Heading } from '../../../../../components/Heading/Heading';
import { BlogPreviewCard } from '../../../../../components/Blog/BlogPreviewCard/BlogPreviewCard';
import { useState } from 'react';
import { Button } from '../../../../../components/Clickables/Buttons/Button';

interface IProps {
  categorySlug: string;
  relatedPosts: Entry<TypeBlogPostSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>[];
  title?: string;
  className?: string;
}

const NUMBER_OF_VISIBLE_POSTS = 3;

export const RelatedBlogPosts = ({
  categorySlug,
  relatedPosts,
  title = 'Related blog posts',
  className,
}: IProps) => {
  const [visibleCount, setVisibleCount] = useState(NUMBER_OF_VISIBLE_POSTS);

  if (relatedPosts.length === 0) {
    return <></>;
  }

  const handleShowMore = () => {
    setVisibleCount(prev => Math.min(prev + NUMBER_OF_VISIBLE_POSTS, relatedPosts.length));
  };
  const hasMore = visibleCount < relatedPosts.length;

  return (
    <Container
      variant="thin"
      className={twMerge(`mt-sm flex flex-col gap-6 sm:gap-8 md:gap-10`, className)}
    >
      <div className="flex w-full flex-col">
        <Heading as="h3" className="m-0 md:text-center">
          {title}
        </Heading>
      </div>
      <div className="flex flex-col items-center gap-6">
        {relatedPosts.map((relatedP, index) => {
          const {
            slug: relatedSlug,
            headerImage: relatedHimg,
            title: relatedTitle,
            postDescription: relatedDescription,
            publishDate: relatedPublishDate,
            subjectTags: relatedTages,
            countryData: relatedCountryData,
          } = relatedP.fields;

          return relatedHimg?.fields.file && categorySlug ? (
            <BlogPreviewCard
              className={index < visibleCount ? '' : 'hidden'}
              key={relatedSlug}
              imageUrl={relatedHimg.fields.file.url}
              categorySlug={categorySlug}
              {...relatedP}
              blogPostSlug={relatedSlug}
              blogPostTitle={relatedTitle}
              blogPostDescription={relatedDescription}
              blogTags={relatedTages}
              publishDate={relatedPublishDate}
              country={relatedCountryData}
            />
          ) : (
            <></>
          );
        })}
        {hasMore && (
          <Button
            variant="textPrimaryDarkBg"
            className="bg-sea-foam mb-4 flex gap-2 p-4"
            onClick={handleShowMore}
          >
            Show more posts
          </Button>
        )}
      </div>
    </Container>
  );
};
